//import action types
import * as types from "../actions/types"

const initialState = {
  client: {},
  publicClient:{},
  clientNotification: [],
  client_Profiles: [],
  detailed_client_Profiles: [],
  error: [],
  client_Boards : [],
};

const clientReducer = (variable = initialState, action) => {
    switch(action.type) {
      case types.get_client:
        return{
          ...variable,
          client: action.payload[0]
        }
        case types.get_public_clients:
        return{
          ...variable,
          client:{},
          publicClient: action.payload[0]
        }
        case types.client_notifications:
          return{
            ...variable,
            clientNotification: action.payload
          }
        case types.get_client_profiles_details:
        return{
          ...variable,
          detailed_client_Profiles: action.payload
        }
        case types.update_client_profiles:
          return{
            ...variable,
            client_Profiles: action.payload[0]
          }
        case types.GET_ALL_CLIENT_BOARDS:
          return{
            ...variable,
            client_Boards : action.payload
          }
        default:
            return variable
    }
}

export default clientReducer